<template>
  <div>
    <v-dialog
      :value="show"
      :transition="
        $vuetify.display.smAndDown
          ? 'dialog-bottom-transition'
          : 'dialog-transition'
      "
      max-width="350"
    >
      <v-card>
        <div class="modal-content text-center py-5 px-5">
          <div class="mb-5">
            <strong>ACH Authorization</strong>
          </div>
          <div class="text-small mb-8">
            <div class="mb-2">
              To confirm your payment, please review the following information:
            </div>
            <div>
              I hereby authorize {{ vendor }} to make a one-time electronic fund
              transfer for <strong>{{ dollars(amountInCents) }}</strong> from my
              bank account.
            </div>
          </div>
          <v-btn
            color="warning"
            rounded
            variant="outlined"
            class="mr-14"
            @click="emit('cancel')"
            >Cancel</v-btn
          >
          <v-btn rounded color="primary" @click="emit('confirm')"
            >Confirm</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
defineProps({
  vendor: {
    type: String,
    default: () => ""
  },
  amountInCents: {
    type: Number,
    default: () => 0
  },
  show: {
    type: Boolean,
    default: () => false
  }
});

const emit = defineEmits(["confirm", "cancel"]);
</script>
